import React, {Component} from 'react';
import {BalanceItem} from "components/dashboard/home/BalanceItem";
import 'assets/sass/dashboard/home/Balances.scss';
import { AppContext } from 'app/state/AppContext';


export class Balances extends Component {
    static contextType = AppContext;
    renderData() {
        if (this.props.data) {
            const { currencyCodes } = this.context;
            return currencyCodes.map((currency, index) => (
                <React.Fragment key={currency}>
                    <BalanceItem
                        balance={this.props.data[currency]}
                        currency={currency}
                        key={currency}
                    />
                    {index === currencyCodes.length - 1 ? null : <span className="division"/>}
                </React.Fragment>
            ));
        } else {
            return "Cargando...";
        }
    }

    render() {
        return (
            <div className="balances">
                <h5 className="dashboard-title">Mis saldos</h5>
                <div className="balances-box">
                    {this.renderData()}
                </div>
            </div>
        );
    }
}
